export const DraggableItemTypes = {
  PIN: "Pin",
  WORK_TASK_CARD: "WorkTaskCard",
};
